import { render, staticRenderFns } from "./client-filter.vue?vue&type=template&id=40220a2e"
import script from "./client-filter.vue?vue&type=script&lang=js"
export * from "./client-filter.vue?vue&type=script&lang=js"
import style0 from "./client-filter.vue?vue&type=style&index=0&id=40220a2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports